import styled, { keyframes , css} from "styled-components";
import rightblackarrow from "../../../images/parent-right-arrow.svg";
import Enquire from "../../../images/connect_envelope_white.svg";
import upblackarrow from "../../../images/up-black-arrow.svg";
import downblackarrow from "../../../images/down-black-arrow.svg";

export const ConnectLineContainer = styled.div`
    position: absolute;
    left: 0%;
    margin-top: -2.2%;
    @media screen and (max-width: 600px){
        left: 18%;
        margin-top: -6%;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: portrait) 
    {
        margin-top: -5%;
    } 
`;
export const ConnectStoriesHeading = styled.div`
    @media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: portrait) 
    {
        display:flex;
        flex-flow:row;
    } 
`
export const ConnectStoriesContainer = styled.div`
    padding: 45px 30px 30px;
     @media screen and (min-width: 1024px){
       height:90vh;
}
    @media screen and (max-width: 1380px){
        width: 100%;
        padding: 30px 30px 0 30px ;
    }
    @media screen and (max-width: 850px){
        width: 100%;
        padding: 15px 10px 0px;
    }
`
export const AutoSaveDraft = styled.div`
   display:flex;
   margin: 0 0 1% 2.5%;
   @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
   {
    margin: 0 0 1% 1.5%;
   }   
`
export const SensitiveWrapper = styled.div`
    display: flex;
    flex-wrap: wrap; 
    @media only screen and (max-width: 520px){
        margin:0 2%;
        flex-direction:${props => props?.bible ? "column-reverse" : ""};
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        width: 96%;
        margin: 0 auto;
    }   
`
export const SelectTemplateDiv = styled.div`
    @media only screen and (min-width: 360px) and (max-width: 740px){
        display: flex;
         flex-flow: column-reverse;
     }
     @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
     {
         width: 100%;
         display:flex;
     }   
`
export const TabsWrapperdiv = styled.div`
    display: flex;
    margin: 0 2%;
    @media only screen and (max-width: 749px){
        margin: 2% auto;
        width:100%;
        flex-flow:column;
        gap:12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        padding-bottom: 10px;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        width: 100%;
        margin: 10px auto;
        margin-left:-1rem;
        display:flex;
        flex-flow:row;
    }
`
export const WritingTips = styled.div`
    display: flex;
    margin: auto 0px auto 2%;
    min-width: max-content;
    cursor:pointer;
    @media only screen and (max-width: 750px){
        border-top: 1px solid rgba(0, 0, 0, 0.2);
        padding-top: 10px;
    }
`
export const PhotoGuide = styled.div`
    display: flex;
    margin: auto 0px auto 1%;
    min-width: max-content;
    cursor:pointer;
    :before { 
        content:'';
        border-right: 1px solid #BEBEBE;
        margin: 0 20px 0; 
        position: relative;
        @media only screen and (max-width: 750px){
            border-right: 0px solid #BEBEBE;
            margin: auto 0px auto 1%;
        }
    }
    @media only screen and (max-width: 750px){
       border-top: 1px solid rgba(0, 0, 0, 0.2);
        padding-top: 10px;
    }
`
export const FAQ = styled.div`
    display: flex;
    margin: auto 0px auto 1%;
    min-width: max-content;
    cursor:pointer;
    :before { 
        content:'';
        border-right: 1px solid #BEBEBE;
        margin: 0 20px 0; 
        position: relative;
        @media only screen and (max-width: 750px){
            border-right: 0px solid #BEBEBE;
            margin: auto 0px auto 1%;
        }
    }
    @media only screen and (max-width: 750px){
        border-top: 1px solid rgba(0, 0, 0, 0.2);
        padding-top: 10px;
    }
`
export const SensitiveArea = styled.div`
    text-align: end;
    flex:auto;
    @media only screen and (max-width: 520px){
        margin: 2%;
    }
    margin: 1% 2%;
    & img {
        width: 15px;
        height: 15px;
        border: 2px solid #fff;
        border-radius: 50%;
        box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 3px 0px;
        margin-top:-3px;
    }
    @media only screen and (min-width: 360px) and (max-width: 740px){
        text-align: left;
        margin: 2% 3%;
        width: 100%
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        margin: 2% 2%;
    }
`
export const SensitiveAreaText = styled.div`
    background-color: #fff;
    margin: 0% 2%;
    left: 1.5vw;
    top: 13vh;
    border-radius: 12px;
    border: 1px solid #E1E1E1;
    & div.sensitive-area-container{
        overflow:auto;
        @media only screen and (max-width: 600px){
            max-height:130px;
            width: 90%;
            margin-right: 10px;
        }
        & ::-webkit-scrollbar{
            width: 5px;
        }
        & ::-webkit-scrollbar-track {
            background: #fff; 
        }
        & ::-webkit-scrollbar-thumb{
            border-radius: 8px;
            background: #C1C1C1; 
        }
        & ::-webkit-scrollbar-thumb:hover {
            background: #C1C1C1; 
        }
    }
    & div.sensitive-area-container-template{
        border-radius: 12px;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);   
        padding: 10px;
        overflow:auto;
        @media only screen and (max-width: 600px){
            max-height:130px;
            width: 100%;
            margin-right: 0px;
        }
        & ::-webkit-scrollbar{
            width: 5px;
        }
        & ::-webkit-scrollbar-track {
            background: #fff; 
        }
        & ::-webkit-scrollbar-thumb{
            border-radius: 8px;
            background: #C1C1C1; 
        }
        & ::-webkit-scrollbar-thumb:hover {
            background: #C1C1C1; 
        }
    }
    & div{
        color: #000;
        font-size: 14px;
        font-family: 'Lato';
        font-weight: 500;
    }
    @media only screen and (max-width: 520px){
        top: 16vh;
        margin: 2%;
    }
`
export const InstructionArea = styled(SensitiveAreaText)`
    background-color: rgba(255, 122, 0, 0.10);
    display:flex;
    flex-direction:row;
    padding: 10px;
    margin: 1% 2% 0 2%;
    & img{
        background-color: rgb(255, 107, 0);
        border-radius: 50%;
        min-width:20px;
        width: 20px;
        height: 20px;
        border: 2px solid rgb(255, 255, 255);
        box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 3px 0px;
        margin-right:5px;
        padding:3px;
    }
    & div{
        padding-right:15px;
    }
    @media only screen and (max-width: 520px){
        width:max-content;
        max-width:95%;
        margin-bottom: 10px;
        & img{
            margin-right:15px;
            width: 22px;
            height: 22px;
        }
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        margin: 3% 2% 1%;
        & img{
            min-width: 25px;
            min-height: 25px;
            margin-right: 10px;
        }
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        margin: 3% 2% 1%;
        & img{
            min-width: 25px;
            min-height: 25px;
            margin-right: 10px;
        }
    }
`
export const SensitiveAreaArrow = styled.img`
    cursor:pointer;
`
export const MessageContainer = styled.div`
    ${props => props.textFocus && `
       border: 1px solid rgb(255, 107, 0);
    `}        
`
export const FarewellContainer = styled.div`
    display:flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    padding: 1.25rem 2rem 0.75rem;
    width: 100%;
    margin: 0 auto;
    background-color: #f3f3f3;
    @media only screen and (max-width:750px){
        background-color: #fff;
        padding: 1.25rem 0.7rem 0.75rem;
    }
    @media only screen and (min-device-width: 751px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        background-color: #fff;
        padding: 1.25rem 0.7rem 0.75rem;
    }
`;
export const TextWrapper = styled.div`
    display: ${({ expanded }) => (expanded ? "block" : "-webkit-box")};
    -webkit-line-clamp: ${({ expanded }) => (expanded ? "unset" : 3)};
    -webkit-box-orient: vertical;
    overflow: hidden;
`;
export const ToggleText = styled.span`
    color: ${({ expanded }) => (expanded ? "#000" : "#FF6B00")};
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    font-family: Lato;
    font-weight: 700;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 1%;
    text-align: center;
`;
export const ToggleButton = styled.button`
    background: none;
    border: none;
    color: #007bff;
    cursor: pointer;
    font-size: 0.9rem;
    margin-top: 0.5rem;
    padding: 0;
`;
export const FarewellTitle = styled.h2`
    font-family: Lato;
    font-weight: 700;
    font-size: 16px;
    line-height: 140%;
    letter-spacing: 1%;
    text-align: center;
    color: #000000;
    margin-bottom:0.75rem;
    @media only screen and (max-width:750px){
        font-size: 14px;
    }
`
export const FarewellDesc = styled.p`
    font-family: Lato;
    font-weight: 700;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 1%;
    text-align: center;
    color: #F66700;
    margin-bottom:0;
    & img{
        top: -2px;
        position: relative;
    }
`
export const WriteMsgCointainer = styled.div`
    overflow: auto;
    display:flex;
    flex-direction:column;
    height:90%;
    transition: all 1.3s ease-in-out;
    overflow: hidden auto;
`
export const MessageTopHeader = styled.div`
    display:flex;
    position: relative;
    flex-wrap: wrap;
`
export const ConnectButtons = styled.div`
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;
    @media only screen and (max-width: 800px){
        flex-flow: column;
        margin-bottom: 10px;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) {
        flex-flow: row;
    }
    @media only screen and (min-device-width: 1200px) {
        margin-bottom: 15px;
        margin-top: 15px;
    }
`
export const WirteALetterButton = styled.div`
    padding: 10px;
    background-color: rgb(255, 107, 0);
    box-shadow:rgb(199, 83, 0) 0px 3px 0px;
    color: rgb(255, 255, 255);
    border-radius: 7px;
    text-align: center;
    font-size: 20px;
    font-family: Lato;
    cursor: pointer;
    margin: 5%;
    font-weight: 700;
    @media only screen and (max-width: 749px){
        margin: 5% 3%;
        width: 95%;
        text-align: center;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        width: 48%;
        margin: 2% 4%;
        margin-bottom: 2rem;
    }
`
export const ConnectPreviewButton = styled.div`
    padding: 10px;
    min-width: 85px;
    background-color: rgb(255, 107, 0);
    box-shadow:rgb(199, 83, 0) 0px 3px 0px;
    color: rgb(255, 255, 255);
    border-radius: 7px;
    text-align:center;
    font-size: 18px;
    font-family: Lato;
    cursor: pointer;
    margin: 6px;
    margin-bottom: 1.5%;
    @media only screen and (max-width: 600px){
        margin-top: 5%;
        width:93%;
        text-align: center;
    }
`
export const ConnectSaveButton = styled.div`
    padding: 10px;
    min-width: 85px;
    text-align:center;
    background-color: rgb(255, 107, 0);
    box-shadow:rgb(199, 83, 0) 0px 3px 0px;
    color: rgb(255, 255, 255);
    border-radius: 7px;
    font-size: 18px;
    font-family: Lato;
    cursor: pointer;
    margin: 6px;
    margin-bottom: 1.5%;
    & span {
        position:relative;
        padding-left:30px;
        font-family: 'Lato-Bold';
        font-size: 18px;
        line-height: 1.2;
        color: #FFFFFF;
    }
    & span:before{
        background: url(${Enquire}) 0 0;
        content:"  ";
        width: 26px;
        height: 22px;
        position:absolute;
        left:0px;
        background-repeat: no-repeat;
        top: 3px;
        @media only screen and (max-width:750px)
        {
            left:0px;
        }
    }
    @media only screen and (max-width: 600px){
        width:93%;
        text-align: center;
        margin-bottom: 12px;
    }
`
export const ConnectChildNameContainer = styled.div`
    display: flex;
    position: relative;
    width: fit-content;
    height: 33px;
    background-color: #FFDCC1;
    border-radius: 20px;
    padding: 4px 10px 7px 6px;
    margin-right: 15px;
    @media only screen and (max-width: 600px){
        margin-top: 4px;
        min-width:130px;
    }
`
export const AddChildContainer = styled.div`
    width: fit-content;
    height: 33px;
    background-color: #fff;
    color: #000;
    border-radius: 20px;
    padding: 4px 10px 7px 6px;
    border: 1px solid #E6E6E6;
    cursor: pointer;
    @media only screen and (max-width: 390px){
        margin-top: 5px;
    }
    @media only screen and (min-width: 390px) and (max-width: 740px){
        margin-top: 10px;
        margin-bottom: 15px;
    }
`
export const ConnectChildName = styled.span`
    font-size: 16px;
    font-family: 'Lato-Bold';
    margin-left: 6px;
`
export const ConnectChildImg = styled.img`
    width: 27px;
    height: 27px;
    border-radius: 50%;
`
export const SentIcon = styled.img`
    display: block;
    margin-left: auto;
    margin-right: auto;
`
export const SuccessTrackedImg = styled.div`
    position: absolute;
    & img{
        position: absolute;
        top: -2.5vh;
        left:-8px;
        width:18px;
        heigth:18px;
        display: flex;
        background-size: cover;
    }
    & {
        display: block;
        position: absolute;
        background-color: #e6e6e6;
        width: 2px;
        top: 18px;
        left: -2.75vh;
        height: 8.75vh;
        transform: translateX(-50%)
     }
    & div{
        display: block;
        position: absolute;
        background-color: #F66700;
        background: linear-gradient(90deg, #F66700 0%, rgba(255, 255, 255, 0.00) 100%);
        width: 2px;
        top: -32px;
        left: 1px;
        height: 18px;
        transform: translateX(-50%);
    }
`;
export const SuccessLastTrackedImg = styled.div`
    position: absolute;
    & img{
        position: absolute;
        top: -2.5vh;
        left:-8px;
        width:18px;
        heigth:18px;
        display: flex;
        background-size: cover;
    }
    & {
        display: block;
        position: absolute;
        background-color: #e6e6e6;
        width: 2px;
        top: 18px;
        left: -2.75vh;
        height: 8.75vh;
        transform: translateX(-50%);
     }
`;
export const RenderChildList = styled.div`
    display: flex;
    margin-bottom: 10px;
    position:relative;
`;
export const AddRecipients = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 5%;
`;
export const AddRecipientsInner = styled.div`
    border-radius: 8px;
    background-color: #F66700;
    box-shadow:rgb(199, 83, 0) 0px 3px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 60px;
    @media screen and (max-width: 850px) {
        width: fit-content;
        margin: 10px auto;
        position: inherit;
    }
`;
export const AddChildCloseIcon = styled.div`
    display: flex;
    -webkit-box-pack: end;
    justify-content: flex-end;
    cursor: pointer;
    margin-top: 5px;
    margin-right: 15px;
`
export const RemoveAttachmentIconDiv = styled.div`
    margin-bottom:2%;
    & img {
        width:22%;
    }
`
export const Multiplechildtextstyle = styled.div`
    color: #fff;
    font-size: 12px;
    font-family: Lato-Bold;
    text-align: center;
    align-self: center,
    padding: 2,
`;
export const Multiplechildstyle = styled.div`
    background-color: #FF6B00;
    border: 2px solid #fff;
    align-items: 'center',
    justify-content: 'center',
    line-height: 1,
    padding: 2,
    height: 24px;
    width: 24px;
    margin-left: 5px;
    border-radius: 50%;
`
export const Templatestyle = styled.div`
    width: fit-content;
    height: 33px;
    color: #000;
    padding: 0px 10px 7px 0px;
    position: relative;
    margin: 1.5% 0 0 1.5%;
    cursor: pointer;
    display:flex;
    @media screen and (max-width: 750px){
        margin: 2% 0 1em 2%;
        font-size:14px;
        width: 100%
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        & {
            margin: 2% 0 0% 0%;
        }
     }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        & {
            margin: 2% 0 0% 2%;
        }
    }
`
export const TemplateSelectedLanguageRadioButton = styled.div`
    display:flex;
     flex-wrap: wrap; 
     @media screen and (max-width: 750px){
        flex-wrap: nowrap;
    }
     & input[type="radio"] {
        appearance: none;
        width: 22px;
        height: 22px;
        border: 2px solid #999;
        border-radius: 50%;
        outline: none;
        cursor: pointer;
        position: relative;
        @media screen and (max-width: 750px){
            width: 18px;
            height: 18px;
        }
      }
      & input[type="radio"]:checked{
        border: 2px solid #ff6b00;
      }
      & input[type="radio"]:checked::before {
        content: '';
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: #ff6b00;
        position: absolute;
        top: 51%;
        left: 51%;
        transform: translate(-50%, -50%);
      } 
`
export const ArrButton = styled.button`
    @media screen and (max-width: 990px){
        position: relative;
        width: 15px;
        height: 20px;
        display: flex;
        margin: 10px 0% 0% 0%;
        background: url(${downblackarrow}) 0 0 no-repeat;
        ${props => props.isTemplateModalVisible && `
            background: url(${upblackarrow}) 0 0 no-repeat;
            `
    }
    }  
`
export const ArrButton2 = styled.button`
    @media screen and (max-width: 990px){
        position: relative;
        width: ${props => props?.isInstructionVisible ? "24px" : "15px"};
        height: 18px;
        display: flex;
        margin: 2% 0% auto 0%;
        background: url(${rightblackarrow}) 0 0 no-repeat; 
        transform: rotate(90deg);
        ${props => props.isInstructionVisible && `
            transform: rotate(0deg);
            `
    }
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) {
        margin: 1% 1% auto 0%;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) {
        margin: 1% 0% auto 0%;
    }
`
export const Templateiconstyle = styled.div`
    background-color: rgb(255, 107, 0);
    border-radius: 50%;
    width: 24px;
    height: 24px;
    border: 2px solid rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 3px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    & img {
        width:12px;
    }
`
const blink = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
`;

export const Circleiconstyle = styled.img`
  margin-right: 10px;
  ${({ isBlinking }) =>
    isBlinking &&
    css`
      animation: ${blink} 1s infinite;
    `}
`;
export const GuidelineName = styled.div`

`
export const GuidelineWrapper = styled.div`
    padding: 10px;
    margin-right: 15px;
`
export const Tourtext = styled.div`
    display: flex;
`
export const ViewNext = styled.span`
    color: #FF6B00;
    cursor: pointer;
        font-weight: bold;
    padding-top: 5px;
    display: inline-block;

`
export const Templatetextstyle = styled.span`
    font-size: 16px;
    font-family: 'Lato-Bold';
    margin-left: 5px;
    align-content: center;
    @media screen and (max-width: 750px){
        font-size:14px;
    }
`
export const TemplateHeading = styled.div`
    display: flex;
    margin: 0 auto 2% auto;
    flex-flow:column;
`
export const Templateiconstylehead = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom:0.5rem;
    & img {
        width:48%;
    }
`
export const Templatetextstylehead = styled.span`
    font-size: 28px;
    font-family: 'Lato';
    font-weight:400;
    line-height:120%;
    margin-top:15px;
`
export const TemplateListContainer = styled.div`
    overflow-x: auto;
    margin: 10px 0px 0 6px;
    display: flex;
    flex-flow:column;
    width: -webkit-fill-available;
    padding: 0 10px 5px 10px; 
    max-height:42vh;
    &::-webkit-scrollbar{
        height: 3px;
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        background: #fff; 
    }
    &::-webkit-scrollbar-thumb{
        border-radius: 8px;
        background: #C1C1C1; 
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #C1C1C1; 
    }
    @media screen and (min-width: 1200px) and (max-width:1400px) {
        max-height:30vh;    
    } 
    @media screen and (min-width: 1600px) and (max-width:1920px) {
        max-height:50vh;    
    } 
    @media screen and (max-width:750px) {
        max-height:50vh;    
    } 
`
export const TempIcondiv = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    @media screen and (min-width: 1180px){
        justify-content: center;
    }
    // @media screen and (min-width: 1200px) and (max-width:1400px) {
    //     padding-left:10em;      
    // } 
`
export const BtnViewStyles = styled.div`
    width: 50%;
    height:60px;
    border-radius: 8px;
    background-color: rgb(246, 103, 0);
    text-align: center;
    box-shadow: rgb(199, 83, 0) 0px 3px 0px;
    margin: 2% auto;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: 1200px) and (max-width:1400px){
        height:50px;
    }
    }
`
export const TemplateDesc = styled.div`
    font-family: Lato;
    font-size: 16px;
    color: rgb(51, 51, 51);
    margin-top: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
`
export const TemplateDiv = styled.div`
    display: flex;
    @media screen and (max-width: 425px){
        flex-direction:column;
    }
`
export const TemplateLeftDiv = styled.div`
    width: 30%;
    text-align: center;
    display: FLEX;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    position: relative;
    box-shadow: 2px 0px 3px 0px #00000010;
    @media screen and (max-width: 425px){
        width: 100%;
    }
`
export const TemplateRightDiv = styled.div`
    width: 100%;
    @media screen and (max-width: 425px){
        width: 100%;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        width: 100%;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        width: 100%;
    }
`
export const ChildSubject = styled.div`
    margin-top: 10px;
    @media screen and (max-width: 600px){
        margin-top: ${({ mobsub }) => (mobsub ? "5px" : "40px")};
    }
`
export const LineSeparator = styled.div`
    background-color: #E6E6E6;
    margin-top:0.5em;
    height: 1px;
    margin-right: 1rem;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        margin-top:0.5em;
    }
    @media only screen and (max-width:750px){
        margin-top:0em;
    }
`
export const ChildMessageBody = styled.div`
    margin-top: 10px;
    height: inherit;
    overflow-y: auto;
    overscroll-behavior: contain;
    touch-action: pan-y;
    &::-webkit-scrollbar{
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        background: #fff; 
    }
    &::-webkit-scrollbar-thumb{
        border-radius: 8px;
        background: #C1C1C1; 
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #C1C1C1; 
    }
    @media screen and (max-width: 600px){
        height: 45vh;
    }
`
export const ChildMessageBodyFull = styled.div`
    margin-top: 10px;
    height: 75%;
    overflow-y: scroll;
    overscroll-behavior: contain;
    touch-action: pan-y;
    padding-right: 1rem;
    &::-webkit-scrollbar{
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        background: #fff; 
    }
    &::-webkit-scrollbar-thumb{
        border-radius: 8px;
        background: #C1C1C1; 
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #C1C1C1; 
    }
    @media screen and (max-width: 600px){
        height: ${({ mobBody }) => (mobBody ? "52vh" : "52vh")};
    }
`
export const ImagePickerContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width:100%;
`
export const ImagePreviewContainer = styled.div`
    display: flex;
    justify-content: left;
    height: 35%;
    max-width:360px;
    @media screen and (min-width: 1400px) {
        height:33%;
    }
    @media screen and (min-width: 1900px) {
        height:30%;
    }
    @media screen and (max-width: 740px){
        display: none;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        display: none;
    }

    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        display: none;
    }
    @media (min-width: 1024px){
        height: 106px;
        width: 160px;
    }
`
export const DeleteImageIcon = styled.div`
    position: relative;
    left: 0px;
    cursor: pointer;
    top:-2px;
    width:32px;
    height:32px;
    border-radius:5px;
    overflow:hidden;
    box-shadow: 0px 3px rgb(193, 193, 193); 
    & img {
        width:100%;
        height:100%;
    }
   : before{
    content:"";
    position:absolute;
    width:100%;
    height:100%;
    top:0;
    left:0;
    background:#000000;
    opacity:0.35;
   }
   : after{
    content:"X";
    font-weight:bold;
    color:#fff;
    font-size:14px;
    position:absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
   }
`
export const BibleVerseIcon = styled.div`
    display:flex;
    border: 1px solid #FF6B00;
    padding: 0.5% 0.5% 0.5% 1%;
    border-radius: 7px;
    margin: 0 2% 0 auto;
    background: #FFFFFF;
    overflow: hidden;
    white-space: nowrap;
    flex-direction: row;
    & img {
        margin-right: 10px;
    }
    & span{
        padding-right:30px;
    }
    & button {
        position: relative;
        width: 18px;
        height: 20px;
        display: flex;
        margin: auto 3% 0% auto;
        background: url(${rightblackarrow}) 0 0 no-repeat;
    @media screen and (max-width: 850px){
        width: 15px;
        margin-left: auto;
    } 
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        margin: auto 1% 0% auto;
    }
}
@media screen and (max-width: 850px){
        margin: 2% auto;
        width:96%;
        padding: 3%;
    }
@media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        margin: 2% auto;
        width: 100%;
        padding: 1%;
        margin-right:0px;
    }
`
export const GalleryIcon = styled.div`
    margin-right:10px;
    & img {
        margin-right: 5px;
        top: -2px;
        position: relative;
    }
    @media screen and (max-width: 430px){
        margin-right:10px;
    }
`
export const GalleryContainer = styled.div`
    display:flex;
    flex-flow:row;
    cursor:pointer;
    position:relative; 
    bottom: -25px;
`
export const TemplateItem = styled.div`
`
export const TempIcon = styled.div`
    text-align: -webkit-center;
    & img {
        max-width: 52px;
    }
    @media (max-width: 430px) {
        & img {
            max-width: 40px; 
        }
    }
`
export const PreviewEditIcon = styled.div`
    cursor: pointer;
`
export const SendMessageButton = styled.div`
    cursor: pointer;
`
export const PreviewContent = styled.div`
    position: absolute;
    top: 20%;
    width: 63%;
    left: 19%;
    padding: 0 10px;
    height: 325px;
    overflow-y: scroll;
    & pre {
        white-space: pre-wrap;       
        white-space: -moz-pre-wrap;  
        white-space: -pre-wrap;      
        white-space: -o-pre-wrap;    
        word-wrap: break-word; 
    }
    &::-webkit-scrollbar{
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        background: #fff; 
    }
    &::-webkit-scrollbar-thumb{
        border-radius: 8px;
        background: #C1C1C1; 
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #C1C1C1; 
    }
`
export const OuterView = styled.div`
  display: flex;
  flex-direction: row;
  padding: 20px 30px;
  flex-basis: 33.333333%;
  flex-wrap: wrap;
  max-height: 160px;
  position: relative;
  overflow: hidden scroll;
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-track {
    background: #fff;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background: #c1c1c1;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #c1c1c1;
  }
  @media screen and (max-width:749px){
    padding: 20px 0px;
  }
`;
export const TemplateWarningProceed = styled.div`
`
export const TemplateWarningCancel = styled.div`
`
export const ImgSeparator = styled.div`
    margin-top: 10px;
    border-bottom: 1px solid lightgrey;
    margin-right: ${props => props?.sensitive ? "0" : "30px"};
`


